const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1159,-809)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.02015,0,0,2.02017,872.216,252.584)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.327,
    y: 275.741,
    width: 396.011,
    height: 396.011,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0.495007)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.41711,2.84217e-14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.495014,0,0,0.495007,-437.039,-125.031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1270.21,1167.29L1347.54,1167.29",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "22.22px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.495014,0,0,0.495007,-180.952,-125.031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1270.21,1167.29L1347.54,1167.29",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "22.22px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.350027,-0.350023,0.350027,0.350023,-435.852,411.805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1270.21,1167.29L1347.54,1167.29",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "22.22px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.350027,0.350023,-0.350027,0.350023,200.233,-504.468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1270.21,1167.29L1347.54,1167.29",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "22.22px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.92351e-16,0.495007,-0.495014,-1.09914e-16,918.156,-323.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1270.21,1167.29L1347.54,1167.29",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "22.22px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.817884,0,0,0.817884,61.9799,114.433)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.356981,0,0,0.495007,115.153,-136.251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526.79,1393.3L734.79,1393.3",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "31.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.356981,0,0,0.495007,115.153,-111.831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526.79,1393.3L734.79,1393.3",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "31.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.495014,0,0,0.495007,25.6434,-125.031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.995,1219.05C466.587,1186.34 449.385,1143.65 449.385,1096.97C449.385,994.129 532.879,910.636 635.719,910.636C738.559,910.636 822.052,994.129 822.052,1096.97C822.052,1143.65 804.85,1186.34 776.442,1219.05C764.355,1234.87 724.243,1273.45 710.719,1321.3L560.719,1321.3C547.194,1273.45 507.082,1234.87 494.995,1219.05Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "27.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.495014,0,0,0.495007,136.491,65.7119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.124,1082.3C466.124,1112.29 441.778,1136.64 411.79,1136.64C381.803,1136.64 357.457,1112.29 357.457,1082.3L466.124,1082.3Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "27.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.495014,0,0,0.495007,25.6434,-125.031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M763.969,1112.64C763.969,1112.64 756.521,1175.27 710.719,1221.94",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "27.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.46933,0.157376,-0.157379,0.469323,211.795,-217.799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M764.916,1062.27C764.916,1062.27 763.719,1060.61 759.484,1054.61",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "27.17px"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdea);
export default __webpack_public_path__ + "static/media/icon-idea.14c90a409133bdad83370c73dbcb3a85.svg";
export { ForwardRef as ReactComponent };